import { useEffect } from 'react';

// Clicking items with the following class names will not trigger the callback
const classNameWhiteList = [
  'flyout-internal',
  'k-calendar-navigation',
  'k-calendar-table',
  'k-calendar-header',
  'k-popup',
  'save-criteria-dialog',
  'delete-criteria-dialog',
  'k-list-content',
];

function useOutsideClick(
  ref: React.RefObject<HTMLElement>,
  callback: () => void,
  whiteList: string[] = classNameWhiteList
) {
  useEffect(() => {
    function handleClickOutside(event: Event) {
      const pathClassNames = event
        .composedPath()
        .map((element) => (element as HTMLElement).className);

      // Check if any of the class names in the composed path match the white list
      const classNameMatch: boolean = pathClassNames.some((className) => {
        if (!className) return false;
        return whiteList.some(
          (whiteListItem) => typeof className === 'string' && className?.includes(whiteListItem)
        );
      });

      if (ref.current && !ref.current.contains(event.target as Node) && !classNameMatch) {
        callback();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
    // Disable the dependancy warning because callback function may not be memoized
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);
}

export default useOutsideClick;
